import type { ApprovalRow, Bill, ProductionDetail, Usage } from "./api";
import { ACCOUNT_NAMES } from "./format";

export function netsToZero(bill: Bill | null): { ok: boolean; sumCents: number } {
  if (!bill) return { ok: false, sumCents: 0 };
  const sumCents = bill.lines.reduce((sum, line) => sum + Math.round(Number(line.amount) * 100), 0);
  return { ok: sumCents === 0, sumCents };
}
export function pullsConfirmed(usage: Usage[]): boolean { return usage.filter((row) => row.supplied_by === "ketosource").every((row) => row.pull_status === "pulled"); }
export function sharedSplit(usage: Usage[]): boolean { return usage.some((row) => row.shares.length > 1); }
export function accountMovements(bill: Bill | null): Array<{ account_code: string; name: string; amount: string }> {
  if (!bill) return [];
  const order: string[] = []; const sums = new Map<string, number>();
  for (const line of bill.lines) { if (!sums.has(line.account_code)) { sums.set(line.account_code, 0); order.push(line.account_code); } sums.set(line.account_code, sums.get(line.account_code)! + Math.round(Number(line.amount) * 100)); }
  return order.map((code) => ({ account_code: code, name: ACCOUNT_NAMES[code] ?? code, amount: (sums.get(code)! / 100).toFixed(2) }));
}
export type PostBlock = "not_awaiting" | "no_bill" | "not_zero" | "same_person" | null;
export function postBlock(detail: ProductionDetail, meEmail: string | null): PostBlock {
  if (detail.production.status !== "Awaiting Arnold") return "not_awaiting";
  if (!detail.bill) return "no_bill";
  if (!netsToZero(detail.bill).ok) return "not_zero";
  if (meEmail && detail.production.first_approved_by && detail.production.first_approved_by.toLowerCase() === meEmail.toLowerCase()) return "same_person";
  return null;
}
export function canPost(detail: ProductionDetail, meEmail: string | null): boolean { return postBlock(detail, meEmail) === null; }
export function blockWords(block: PostBlock): string | null {
  switch (block) {
    case "not_awaiting": return "This production is not awaiting approval.";
    case "no_bill": return "No bill has been computed for this production.";
    case "not_zero": return "The bill does not net to zero; it cannot be posted.";
    case "same_person": return "You gave the first approval; a second person must post this.";
    default: return null;
  }
}
export function queueWords(row: ApprovalRow): string { return `${row.production_key} · ${row.entity_id} · Path ${row.path} · ${row.line_count} SKUs · Inventory 630 ${row.total_630} ${row.book_currency}${row.manual_line_count ? ` · ${row.manual_line_count} manual line${row.manual_line_count > 1 ? "s" : ""}` : ""}`; }
